import { Options, Vue } from "vue-class-component";
import { tabletsModule, VIEW_MODES } from "@/store/modules/tablets.module";
import TableLite from "vue3-table-lite/ts";
import { FilterTypes } from "@/store/types/tablets";
import { reactive } from "vue";
import vSelect from "vue-select";
import tabletGroupsAccessService from "@/services/da/tablet-groups.service";
import { DocumentData, FirestoreError, QueryDocumentSnapshot, QuerySnapshot, Unsubscribe } from "firebase/firestore";
import ModalComponent from "@/components/modal.component.vue";
import TabletTile from "@/components/tablet-tile.component.vue";
import Popover from "@/components/popover.component.vue";
import tabletsService from "@/services/da/tablets.service";

const itemsPerRow = 4

@Options({
    components: {
        vSelect,
        ModalComponent,
        TableLite,
        TabletTile,
        Popover
    },
    beforeRouteEnter: async (to, from, next) => {
        const snapshot = await tabletsService.getCollectionDocs()
        await tabletsModule.load(snapshot.docs);
        next();
    },
    beforeRouteLeave: () => tabletsModule.reset()
})
export default class TabletsPageComponent extends Vue {

    private selectedId = 0
    private scrollTop = 0

    searchString = "";
    groupId = [];

    onlineFilterOn = false;
    offlineFilterOn = false;

    liveUpdateSubscription?: Unsubscribe

    groups: any[] = [];

    get items() { return tabletsModule.filtered; }
    get perPage() { return tabletsModule.perPage; }
    get currentPage() { return tabletsModule.cPage; }
    get viewMode() { return tabletsModule.viewMode; }
    get modes() { return VIEW_MODES }

    get online() { return tabletsModule.online; }
    get offline() { return tabletsModule.offline; }

    get table() {
        return reactive({
            columns: [
                {
                    label: "",
                    field: "status",
                    width: "15%",
                },
                {
                    label: "Name",
                    field: "Name",
                    width: "60%"
                },
                {
                    label: "Group",
                    field: "DeviceGroupName",
                    width: "15%"
                },
                {
                    label: "Actions",
                    field: "actions",
                    width: "10%"
                }
            ]
        })
    }

    get filtersUsed() {
        return this.onlineFilterOn || this.offlineFilterOn ||
            this.searchString.length > 0 || this.groupId.length > 0
    }

    async reloadTablets() {
        await tabletsModule.reloadCommand(this.selectedId)
    }

    async takeSnapshot() {
        await tabletsModule.takeSnapshotCommand(this.selectedId)
    }

    created() {
        tabletGroupsAccessService.getCollectionDocs().then(
            (snapshot) => this.groups = snapshot.docs.map(
                (doc: QueryDocumentSnapshot<DocumentData>) => doc.data()));
    }

    get tileHeightPx() {
        return window.screen.availWidth <= 1440 ? 283.81 : 370
      }

    renderTile(tileIndex: number) {
        const from = Math.floor(this.scrollTop / this.tileHeightPx) * itemsPerRow
        const to = from + (itemsPerRow * 4)
        return tileIndex >= from && tileIndex < to
      }

    onSearch() {
        const value = (this.searchString.length < 1 ? undefined : this.searchString);
        tabletsModule.filter({ value, type: FilterTypes.MATCH });
    }

    onStatusFilterChange() {
        tabletsModule.filter({ value: this.onlineFilterOn, type: FilterTypes.ONLINE });
        tabletsModule.filter({ value: this.offlineFilterOn, type: FilterTypes.OFFLINE });
    }

    onGroupFilterChange() {
        tabletsModule.filter({ value: this.groupId, type: FilterTypes.GROUP });
    }

    switchView(mode: VIEW_MODES) {

        tabletsModule.viewModeUpdate(mode);

        if (mode == VIEW_MODES.GRID) {
            this.liveUpdateSubscription = tabletsService.getSnaphostCollection(
                (snapshot: QuerySnapshot<DocumentData>) => {
                    tabletsModule.load(snapshot.docs)
                },
                (error: FirestoreError) => console.error(error),
                () => console.log('complete')
            )
        } else if (this.liveUpdateSubscription != undefined) {
            this.liveUpdateSubscription()
        }
    }

    resetComponentState() {
        this.selectedId = 0
    }

    onSelect(id: number) {
        this.selectedId = id
    }

    unmounted() {
        if (this.liveUpdateSubscription != undefined) {
            this.liveUpdateSubscription()
        }
    }
}
